import { RootState } from '../store'

export default function selectUserUtilityIntegration(state: RootState) {
  return state.user.user?.profile?.latest_utility_integration
}
